import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

/**
 * Initialise store values
 * @returns void
 */
export const useCriteriaStoreInit = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const init = useStore(store, (s) => s.init);

    return init;
};
